// assets/w-main-collection.js
(() => {
  // Empêcher les doubles bindings si la section est rendue plusieurs fois
  if (window.__w_main_collection_bound) return;
  window.__w_main_collection_bound = true;

  // Délégation d'événement : on écoute la grille de la page collection (ou document à défaut)
  const root =
    document.querySelector('.w-collection-grid') ||
    document.querySelector('#CollectionProductGrid') ||
    document;

  async function refreshCartUI() {
    // Recharge l’icône panier + le cart-drawer via l’endpoint sections
    const res = await fetch('/?sections=cart-drawer,cart-icon-bubble', {
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return;
    const json = await res.json();
    const tmp = document.createElement('div');

    // bulle
    if (json['cart-icon-bubble']) {
      const bubbleTarget = document.querySelector('#cart-icon-bubble, .cart-icon-bubble');
      tmp.innerHTML = json['cart-icon-bubble'];
      const bubbleNew = tmp.firstElementChild;
      if (bubbleTarget && bubbleNew) bubbleTarget.replaceWith(bubbleNew);
      tmp.innerHTML = '';
    }

    // drawer
    if (json['cart-drawer']) {
      const oldDrawer = document.querySelector('cart-drawer');
      tmp.innerHTML = json['cart-drawer'];
      const newDrawer = tmp.querySelector('cart-drawer');
      if (oldDrawer && newDrawer) oldDrawer.replaceWith(newDrawer);
      tmp.innerHTML = '';
    }
  }

  function openDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    // fallback : clique un éventuel trigger
    document.querySelector(
      '[data-cart-trigger], [data-drawer-toggle="cart"], button[aria-controls="CartDrawer"], .header__icon--cart'
    )?.click();
  }

  async function addToCart(variantId, quantity = 1) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity }),
    });
    if (!r.ok) throw new Error(`add failed (${r.status})`);
  }

  // Capte les clics sur tes boutons .js-pl-add
  root.addEventListener(
    'click',
    async (e) => {
      const btn = e.target.closest('.js-pl-add[data-variant-id]');
      if (!btn || !root.contains(btn)) return;

      // Si placé dans un quick-add Dawn, laisse Dawn gérer (sécurité)
      if (btn.closest('.quick-add, quick-add-modal, modal-dialog')) return;

      e.preventDefault();
      e.stopPropagation();

      const variantId = btn.dataset.variantId;
      if (!variantId) {
        console.warn('[w-main-collection] data-variant-id manquant sur', btn);
        return;
      }

      // optionnel : lecture d'une quantité si tu ajoutes data-qty sur le bouton
      const qty = Number(btn.dataset.qty || 1);

      // état loading simple
      btn.disabled = true;
      btn.classList.add('is-loading');

      try {
        await addToCart(variantId, qty);
        await refreshCartUI();
        // ouvre le drawer après rafraîchissement
        requestAnimationFrame(openDrawer);
      } catch (err) {
        console.error('[w-main-collection] erreur add', err);
      } finally {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      }
    },
    { passive: false }
  );
})();
